import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Pipe({
  name: 'votingAnswersQuestion',
})
export class VotingAnswersQuestionPipe implements PipeTransform {

  constructor() { }

  transform(answers: any[], answerId: string) {
    return answers.map(item => {
      return {id: item.answers[answerId], ponderation: item.ponderation.ponderation }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/voting/voting-answer-question.ts